<template>
	<div class="page" style="padding-bottom:0.5rem">
		<van-nav-bar title="帮助中心" fixed placeholder v-show="this.$UserAgent.indexOf('Html5Plus')==-1?true:false" />

		<van-empty description="什么都没有" image="search" v-if="show_empty"></van-empty>

		<van-collapse v-model="activeName" accordion size="large" v-if="!show_empty">
			<van-collapse-item v-for="(item, index) in list" :title="item.title" :name="item.id">
				<div v-html="item.content"></div>
			</van-collapse-item>
		</van-collapse>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Collapse,
		CollapseItem
	} from 'vant';
	Vue.use(Collapse)
	Vue.use(CollapseItem)
	export default {
		data() {
			return {
				activeName: '0',
				list: [],
				show_empty: false
			}
		},
		created() {
			this.$ApiUtil.Help.index().then((res) => {
				this.show_empty = res.length < 1 ? true : false
				this.list = res
				// if(!this.show_empty){
				// 	this.activeName = res[0].id
				// }

			})
		}
	}
</script>

<style>
</style>
